export default "__VITE_ASSET__I_UTY4qn__"